export const SEND_LEAD_REQUEST = {
  init: 'leads/SEND_LEAD_REQUEST/init',
  request: 'leads/SEND_LEAD_REQUEST/request',
  success: 'leads/SEND_LEAD_REQUEST/success',
  conflict: 'leads/SEND_LEAD_REQUEST/conflict',
  failure: 'leads/SEND_LEAD_REQUEST/failure',
} as const;

export const LEADS_STORE_NAME = 'leads' as const;
